var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 16.6667,
    fill: "#333333",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8632 20.5396L20.2288 26.9052C20.3427 27.0191 20.4024 27.1533 20.4079 27.3078C20.4126 27.4623 20.3501 27.6039 20.2206 27.7327C20.0927 27.8575 19.9549 27.9211 19.8075 27.9234C19.6608 27.925 19.5227 27.8614 19.3932 27.7327L12.2774 20.6169C12.1752 20.5139 12.1034 20.4093 12.062 20.3032C12.0207 20.1971 12 20.0809 12 19.9545C12 19.8281 12.0207 19.7118 12.062 19.6057C12.1034 19.4996 12.1752 19.3954 12.2774 19.2932L19.3932 12.1762C19.5024 12.067 19.6354 12.0085 19.7923 12.0007C19.9499 11.9929 20.093 12.0514 20.2218 12.1762C20.3505 12.305 20.4149 12.4439 20.4149 12.5929C20.4149 12.7427 20.3505 12.882 20.2218 13.0107L13.862 19.3693H27.4148C27.5818 19.3693 27.7211 19.4251 27.8326 19.5366C27.9442 19.6482 28 19.7875 28 19.9545C28 20.1214 27.9442 20.2607 27.8326 20.3723C27.7211 20.4839 27.5818 20.5396 27.4148 20.5396H13.8632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/BackIcon.95a4843e4a2e2eef554c167d74d78ea3.svg";
export { ForwardRef as ReactComponent };